export default ({
  pageState: { editorAdders },
  data: { position }
}) => {
  return {
    editorAdders: editorAdders.map((val, i) => position === i)
  }; 
};
